<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">About Us</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dashboard">Home</router-link></li>
                            <li class="breadcrumb-item active">About Us</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div>
            </section>
            <section class="content edit_profile">
                <div class="container-fluid">
                    <div class="card">
						<div class="card-body">
							<div class="overflow-auto">
								<p class="mt-3">Current Page: {{ currentPage }}</p>

								<b-table
									id="my-table"
									:items="myreferral"
									:per-page="perPage"
									:current-page="currentPage"
									hover
									:fields="fields"
								>
									<template #cell(investor_name)="data">
										<span class="">
											<img width="40" height="40" src="../assets/image/default_profile.svg" alt="">
											{{ data.item.investor_name }}
										</span>
									</template>
									<template #cell(deposit_amount)="data">
										<span class="badge badge-success">${{ data.item.deposit_amount }}</span>
									</template>
									<template #cell(product_type)="data">
										<span class="fs-6" v-if="data.item.product_type =='FUND_MANAGER'">FUND MANAGER</span>
										<span class="fs-6" v-else>{{ data.item.product_type ? data.item.product_type : '-' }}</span>
									</template>
								</b-table>

								<b-pagination
									v-model="currentPage"
									:total-rows="rows"
									:per-page="perPage"
									aria-controls="my-table"
								>
								</b-pagination>
							</div>
						</div>
					</div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import swal from 'sweetalert'
// import jwt_decode from "jwt-decode"

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
    name: "About",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        // VuePhoneNumberInput
    },
	data() {
		return {
			perPage: 3,
			currentPage: 1,
			fields: [
				{
					key: 'investor_name',
					label: 'Name',
					sortable: true
				},
				{
					key: 'deposit_amount',
					label: 'Deposit',
					sortable: true
				},
				{
					key: 'product_type',
					label: 'Product Type',
					sortable: false
				},
				{
					key: 'broker_name',
					label: 'Broker',
					sortable: false
				},
			],
			myreferral: [],
			// items: [
			// 	{ id: 1, first_name: 'Fred', last_name: 'Flintstone' },
			// 	{ id: 2, first_name: 'Wilma', last_name: 'Flintstone' },
			// 	{ id: 3, first_name: 'Barney', last_name: 'Rubble' },
			// 	{ id: 4, first_name: 'Betty', last_name: 'Rubble' },
			// 	{ id: 5, first_name: 'Pebbles', last_name: 'Flintstone' },
			// 	{ id: 6, first_name: 'Bamm Bamm', last_name: 'Rubble' },
			// 	{ id: 7, first_name: 'The Great', last_name: 'Gazzoo' },
			// 	{ id: 8, first_name: 'Rockhead', last_name: 'Slate' },
			// 	{ id: 9, first_name: 'Pearl', last_name: 'Slaghoople' }
			// ]
		}
    },
    computed: {
		rows() {
			return this.myreferral.length
		}
    },
	async mounted(){
		try {
			let referralResponse = await axios.get(`investor/${localStorage.user_id}/referral/`)
            this.myreferral = referralResponse.data.data
            // console.log('Referral: ', this.myreferral)
		} catch (e) {
			// console.log('Error Robot: ', e.response)

            // alert(e.message)
            swal('Oppss!!!', e.message, 'warning', {
                button: "OK"
            })
		}
	}
}
</script>

<style scoped>
.customPagination > li > a {
  color: white;
}

.customPagination > li.active > a,
.customPagination > li > a:hover
{
  color: white;
  background-color: red !important;
}
.edit_profile img.img_identity{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile img.img_identity2{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile .photo_upload input[type="file"] {
    display: none;
}
.edit_profile .photo_upload .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 40px;
    display: flex;
    /* width: 50%; */
    align-items: center;
    justify-content: center;
}

.edit_profile .form-group{
    margin-bottom: 5px;
}
.edit_profile .form-group label{
    font-size: 10pt;
    margin: 0;
}
.edit_profile input.form-control{
    padding: 15px;
}

.edit_profile .btn_outline_red{
    padding: 10px !important;
}
</style>